
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strategy",
      function () {
        return require("private-next-pages/strategy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strategy"])
      });
    }
  